<div class="pb-2 row">
    @if(availableOrgUnitTypes){
        <div>
            <tm-filter-input-selector [value]="newOrgUnit.type" 
                                      [labelValue]="ouTypeLabel" 
                                      [placeholderValue]="placeholderValue"
                                      [list]="availableOrgUnitTypes" 
                                      (onNewOrgUpdated)="onOrgTypeUpdated($event)"></tm-filter-input-selector>
          
        </div>
    }
    @if(newOrgUnit.type){
        <div>
            <tm-filter-input-selector [value]="newOrgUnit.name" 
                                      [labelValue]="ouNameLabel" 
                                      [list]="availableOrgUnitNames" 
                                      (onNewOrgUpdated)="onOrgNameUpdated($event)"></tm-filter-input-selector>
        </div>
    }
   
</div>
@if(newOrgUnit.type === 'Organization' || newOrgUnit.type === 'Team' || newOrgUnit.type === 'tag'){
    <div class="alert alert-warning" role="alert">
        {{orgUnitTypeError}}
    </div> 
}

<div class="text-end mt-2">
    <button class="btn btn-sm edit-btn edit-btn-save" 
            [hidden]="!(newOrgUnit.type && newOrgUnit.name)"
            [disabled]="newOrgUnit.type === 'Organization' || newOrgUnit.type === 'Team' || newOrgUnit.type === 'tag'" 
            (click)="sendEvent(newOrgUnit)">{{'orgUnits_save' | translate}}</button>

    <button class="btn btn-sm btn- edit-btn" 
            (click)="sendEvent(null)">{{'orgUnits_cancel' | translate}}</button>
</div>